<template>
  <div class="team-members">
    <div class="tea-list">
      <div v-for="(item, index) in teaList" :key="item.id" class="tea-item">
        <div class="head-portrait">
          <img :src="item.picurl || avatar" />
          <label class="uploading" :for="'avatar' + index">{{
            $t("pages_experimentView_teamMembers_863")
          }}</label>
          <input
            v-show="false"
            type="file"
            :id="'avatar' + index"
            style="position: absolute; clip: rect(0 0 0 0)"
            accept="image/png, image/jpeg, image/gif, image/jpg"
            @change="uploadImg($event, item)"
          />
        </div>
        <div class="info">
          <ul-form
            :model="item"
            :ref="'info' + index"
            :rules="rules"
            label-width="80px"
          >
            <ul-form-item
              :label="$t('pages_experimentView_teamMembers_857')"
              prop="teacher"
              class="teacher"
            >
              <ul-input
                v-model="item.teacher"
                :placeholder="$t('pages_experimentView_teamMembers_858')"
              ></ul-input>
              <div class="move" v-if="teaList.length >= 2">
                <i
                  :class="`iconfont icon-shangyi1 ${
                    index == 0 ? 'setAsh' : ''
                  }`"
                  @click="moveUp(index)"
                ></i>
                <i
                  :class="`iconfont icon-shangyi1-copy ${
                    index == teaList.length - 1 ? 'setAsh' : ''
                  }`"
                  @click="moveDown(index)"
                ></i>
                <i class="iconfont icon-shanchu" @click="delTea(index)"></i>
              </div>
            </ul-form-item>
            <ul-form-item
              :label="$t('pages_experimentView_teamMembers_859')"
              prop="school"
            >
              <ul-input
                v-model="item.school"
                :placeholder="$t('pages_experimentView_teamMembers_860')"
              ></ul-input>
            </ul-form-item>
            <ul-form-item
              :label="$t('pages_experimentView_teamMembers_861')"
              prop="introduce"
            >
              <ul-input
                type="textarea"
                resize="none"
                :autosize="{ minRows: 3, maxRows: 3 }"
                v-model="item.introduce"
                :placeholder="$t('pages_experimentView_teamMembers_862')"
              ></ul-input>
            </ul-form-item>
          </ul-form>
        </div>
      </div>
    </div>
    <div class="add-tea" @click="addTea">
      <i class="iconfont icon-tianjiaxuanxiang"></i>
      {{ $t("pages_experimentView_teamMembers_864") }}
    </div>
    <div class="line"></div>
    <ul-button type="primary" @click="save()">{{
      $t("pages_experimentView_teamMembers_865")
    }}</ul-button>
    <cropper ref="cropperDialog" @upData="upDataPicurl"></cropper>
  </div>
</template>

<script>
import { getTeamTea, saveTeamTea } from "@/api/courseApi/virtual.js";
import cropper from "./components/cropper.vue";
import avatar from "@/assets/images/avatar.png";
export default {
  components: {
    cropper,
  },
  data() {
    return {
      avatar,
      teaList: [],
      rules: {
        teacher: [
          {
            required: true,
            message: this.$t("pages_experimentView_teamMembers_866"),
            trigger: "blur",
          },
          {
            max: 100,
            message: this.$t("pages_experimentView_teamMembers_867"),
            trigger: "blur",
          },
        ],
        school: [
          {
            required: true,
            message: this.$t("pages_experimentView_teamMembers_868"),
            trigger: "blur",
          },
          {
            max: 100,
            message: this.$t("pages_experimentView_teamMembers_869"),
            trigger: "blur",
          },
        ],
        introduce: [
          {
            max: 10000,
            message: this.$t("pages_experimentView_teamMembers_870"),
            trigger: "blur",
          },
        ],
      },
      picurl: null,
    };
  },
  computed: {
    courseId() {
      return this.$route.params.id;
    },
  },
  created() {
    this.getTeaList();
  },
  methods: {
    uploadImg(e, item) {
      this.picurl = item;
      let data = {
        title: this.$t("pages_experimentView_teamMembers_871"),
        fixedNumber: 16,
      };
      this.$refs.cropperDialog.uploadImg(e, data);
    },
    upDataPicurl(url) {
      this.picurl.picurl = url;
    },
    getTeaList() {
      getTeamTea({ courseId: this.courseId }).then(({ result }) => {
        if (result.length == 0) {
          this.addTea();
        } else {
          this.teaList = result;
        }
      });
    },
    moveUp(index) {
      let temp = this.teaList.splice(index, 1);
      this.teaList.splice(index - 1, 0, temp[0]);
    },
    moveDown(index) {
      let temp = this.teaList.splice(index, 1);
      this.teaList.splice(index + 1, 0, temp[0]);
    },
    delTea(index) {
      this.teaList.splice(index, 1);
    },
    addTea() {
      let data = {
        picurl: "",
        teacher: "",
        school: "",
        introduce: "",
      };
      this.teaList.push(data);
    },
    save() {
      let flag = true;
      for (let i = 0; i < this.teaList.length; i++) {
        this.teaList[i].index = i + 1;
        let info = `info${i}`;
        this.$refs[info][0].validate((valid) => {
          if (!valid) {
            flag = false;
          }
        });
      }
      if (!flag) {
        return;
      }

      saveTeamTea(this.teaList, this.courseId).then(() => {
        this.$message({
          message: this.$t("pages_experimentView_teamMembers_872"),
          type: "success",
        });
        this.getTeaList();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.team-members {
  padding-top: 32px;
  .tea-list {
    .tea-item {
      display: flex;
      margin-bottom: 10px;
      .head-portrait {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 20px;
        img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
        }
        .uploading {
          color: #8d77fb;
          cursor: pointer;
          margin-top: 8px;
        }
      }
      .info {
        flex: 1;
        .teacher {
          .ul-form-item__content {
            display: flex;
            .move {
              margin-left: 24px;
              i {
                font-size: 18px;
                cursor: pointer;
                color: #969696;
                margin-right: 16px;
                &:last-child {
                  margin-right: 0;
                }
              }
              .setAsh {
                color: #eee;
                cursor: no-drop;
              }
            }
          }
        }
      }
    }
  }
  .add-tea {
    margin-top: 10px;
    display: inline-block;
    color: #8d77fb;
    cursor: pointer;
    i {
      font-size: 14px;
    }
  }
  .line {
    border-top: 1px dashed #e3e3e9;
    margin: 32px 0 20px;
  }
}
</style>